var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellOffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.595 31.5C20.3313 31.9546 19.9528 32.332 19.4974 32.5943C19.0419 32.8566 18.5256 32.9947 18 32.9947C17.4745 32.9947 16.9581 32.8566 16.5027 32.5943C16.0473 32.332 15.6687 31.9546 15.405 31.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.945 19.5C27.2777 17.0571 26.9595 14.5321 27 12",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39 9.39001C9.1294 10.2354 8.99792 11.1153 9 12C9 22.5 4.5 25.5 4.5 25.5H25.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 12C27.0023 10.3696 26.5618 8.76921 25.7254 7.36969C24.889 5.97017 23.6881 4.82413 22.2511 4.05401C20.814 3.28388 19.1947 2.91859 17.5662 2.99715C15.9377 3.07571 14.3611 3.59517 13.0049 4.50005",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3L33 33",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOffIcon);
export default __webpack_public_path__ + "static/media/bell-off-icon.a93484e056e73ee3a9a14502d1d6c916.svg";
export { ForwardRef as ReactComponent };